var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VNavigationDrawer',{staticStyle:{"box-shadow":"0px 6px 16px rgba(216, 220, 240, 0.5)"},attrs:{"bottom":"","floating":"","permanent":"","width":"320px","value":true}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }